export const Links = {
    DonVi: {
        Xem: "/donvi/xem",
        DanhSach: "/donvi",
        Luu: "/donvi/luu",
        ChiTiet: "/donvi/chitiet",
        Xoa: "/donvi/xoa"
    },
    BaoHiem:{
        Xem: "/baohiem/xem",
        Them: "/baohiem/them",
        ChiTiet: "/baohiem/chitiet",
        DanhSach: "/baohiem",
        Luu: "/baohiem/luu",
        Xoa: "/baohiem/xoa"
    },
    ThuLaoNguoiDaiDien: {
        DanhSach: "/thulaonguoidaidien",
        ChiTiet: "/thulaonguoidaidien/chitiet"
    },
    NhanVien:
    {
        DanhSach: "/nhansu",
        ChiTiet: "/nhansu/chitiet",
        Xem: "/nhansu/xem",
        XoaNhanVien: "/nhansu/xoa",
        HoSoCaNhan: "/hosocanhan",
        ThongKe: "/nhansu/thongke",
    },
    NguoiPhuThuoc: {
        CaNhan: "/nhansu/nguoiphuthuoc",
        XemToanDonVi: "/nhansu/nguoiphuthuoc/toandonvi",
        QuanLyToanDonVi: "/nhansu/nguoiphuthuoc/quanly",
    },
    HoSoCaNhan: {
        Xem: "/hosocanhan",
        SuaCoBan: "/hosocanhan/coban",
        SuaDayDu: "/hosocanhan/tatca",
    },
    NhanSuKhac: {
        DanhSach: "/nhansukhac",
        LuongKhenThuong: "/luong/khenthuongnhansukhac",
        ChiTietLuongKhenThuong: "/luong/khenthuongnhansukhac/chitiet",
    },
    ToBan: {
        DanhSach: "/toban",
        ChiTiet: "/toban/chitiet",
        Xem: "/toban/xem"
    },
    NguoiDung: {
        DanhSach: "/nguoidung",
        ChiTiet: "/nguoidung/chitiet"
    },
    ChucNang: {
        DanhSach: "/chucnang",
        PhanChucNang: "/phanchucnang"
    },
    Quyen: {
        ChiTiet: "/quyen/chitiet",
        DanhSach: "/quyen",
        PhanQuyen: "/phanquyen"
    },
    Login: {
        SSO: "/loginSSO"
    },
    Logout: {
        SSO: "/logoutSSO",
    },
    CasService: {
        CasClient: "/c/portal/login"
    },
    Setting: {
        CauHinhHeThong: "/setting",
        PGDPhuTrach: "/pgdphutrach",
    },
    ChamCong: {
        QuanTriChamCongThang: "/chamcongthang",
        ChiTietChamCongThang: "/chamcongthang/chiTiet",
        DuyetChamCong: "/chamcongthang/Duyet",
        LDPhongDuyetChamCong: "/chamcongthang/LDPhongDuyet",
        LDPhuTrachDuyetChamCong: "/chamcongthang/LDPhuTrachDuyet",
        ThemChamCong: "/chamcongthang/Them",
        XoaChamCong: "/chamcongthang/Xoa",
        TrinhChamCong: "/chamcongthang/Trinh",
        QuanTriChamNgoaiGio: "/chamngoaigio",
        ChiTietChamNgoaiGio: "/chamngoaigio/chiTiet",
        ThemNgoaiGio: "/chamngoaigio/Them",
        TrinhNgoaiGio: "/chamngoaigio/Trinh",
        XoaNgoaiGio: "/chamngoaigio/Xoa",
        DuyetNgoaiGio: "/chamngoaigio/Duyet",
        LDPhongDuyetNgoaiGio: "/chamngoaigio/LDPhongDuyet",
        LDPhuTrachDuyetNgoaiGio: "/chamngoaigio/LDPhuTrachDuyet",
        ThongKeChamCong: "/chamcong/thongke",
    },
    HopDong: {
        DanhSach: "/hopdong/danhsach",
        ChiTiet: "/hopdong/chitiet",
        Xem: "/hopdong/xem",
        CaNhan: "/hopdongcanhan",
        CanhBao: "/hopdong/canhbao",
        CauHinhMau: "/hopdong/cauhinhmau",
        HopDongDienTu: "/hopdongdientu",
        ChiTietHopDongDienTu: "/hopdongdientu/chitiet",
    },
    DaoTao: {
        DanhSach: "/daotao/danhsach",
        ChiTiet: "/daotao/chitiet",
        Xem: "/daotao/xem",
        BaoCao: "/daotao/baocao"
    },
    DangKyDaoTao: {
        DanhSachNam: "/dangkydaotaonam",
        ChiTiet: "/dangkydaotaonam/chitiet",
        Xem: "/dangkydaotaonam/xem",
        PheDuyetTongHop: "/duyetdangkydaotaonam",
        PheDuyetCaNhan: "/duyetdangkydaotao",
        DanhSachCaNhan: "/dangkydaotao",
        ChiTietCaNhan:"/dangkydaotao/chitiet"
    },
    KPI: {
        KPICaNhan: "/kpi/canhan",
        ChiTietKPI: "/kpi/chitiet",
        ThemKPI: "/kpi/them",
        LanhDaoPhongDuyet: "/kpi/lanhdaophongduyet",
        LanhDaoPhuTrachDuyet: "/kpi/lanhdaophutrachduyet",
        LanhDaoDonViDuyet: "/kpi/lanhdaodonviduyet",
        KPIPhongBan: "/kpi/phongban",
        DuyetKPI: "/kpi/duyet",
        YKienKPI: "/kpi/ykien",
        ThongKe: "/kpi/thongke",
        TongHopKPI: "/tonghopkpi",
        VanPhongGiaoViec: "/kpi/vanphonggiaoviec",
        AnGiaoViec: "/kpi/angiaoviec"
    },    
    Phep: {
        DanhSachDangKy: "/phep",
        DanhSachPheDuyet: "/pheduyetphep",
        PheDuyet: "/phep/duyet",
        PheDuyetTatCa: "/phep/duyettatca",
        ChiTiet: "/phep/chitiet",
        Xoa: "/phep/xoa",
        Xem: "/phep/xem",
        CauHinh: "/phep/cauhinh",
        QuanLyPhepNam: "/phep/phepnam",
        KhoiTaoPhepNam: "/ngayPhepTrongNam/khoiTaoPhepNam",
        luuNgayPhepTrongNam: "/ngayPhepTrongNam/luuNgayPhepTrongNam",
        CauHinhYKien: "/phep/cauhinhykien",
        TongHop: "/tonghopphep"
    },
    NgoaiGio: {
        DangKy: "/themgio/dangky",
        Xem: "/themgio/xem",
        DanhSach: "/themgio",
        PheDuyet: "/pheduyetthemgio",
        TongHop: "/tonghopthemgio"
    },
    ThuNhapCaNhan: {
        XemThuNhap: "/thunhap/xem"    
    },
    Luong: {
        QuanLyLuong: "/luong/quanlyluong",
        DanhSach: "/luong/danhsach",
        BoSung: "/luongbosung",
        ChiTietLuongBoSung: "/luongbosung/chitiet",
        TrinhLuong: "/luong/Trinh",
        DuyetLuong: "/luong/Duyet",
        LuuLuong: "/luong/LuuLuong",
        ChiTietThueThang: "/thuethang/chitiet",
        QuanTriTinhThue: "/thuethang",
        ChiTietKhenThuongUngHo: "/khenthuongungho/chitiet",
        KhenThuongUngHo: "/khenthuongungho",
        CongDoanPhi: "/congdoanphi",
        ChiTietCongDoanPhi: "/congdoanphi/chitiet",
        PhatSinhTinhThue: "/phatsinhtinhthue",
        ChiTietPhatSinhTinhThue: "/phatsinhtinhthue/chitiet",
        ThanhToanLuongNQL: "/luong/thanhtoanluongnql",
        ChiTietThanhToanLuongNQL: "/luong/thanhtoanluongnql/chitiet",
        DanhSachPhuCapTGV: "/phucaptgv",
        ChiTietPhuCapTGV: "/phucaptgv/chitiet",
        DanhSachLuongCoBan: "/luong/luongcoban",
        ChiTietLuongCoBan: "/luong/luongcoban/chitiet",
        DanhSachLuongPhuCap: "/luong/luongphucap",
        ChiTietLuongPhuCap: "/luong/luongphucap/chitiet",
        DanhSachLuongHoanThanhNhiemVu: "/luong/luonghtnv",
        ChiTietLuongHoanThanhNhiemVu: "/luong/luonghtnv/chitiet",
        DanhSachLuongBoSungTruongBKS: "/luong/luongbstbks",
        ChiTietLuongBoSungTruongBKS: "/luong/luongbstbks/chitiet",
        DanhSachLuongThemGio: "/luong/luongthemgio",
        ChiTietLuongThemGio: "/luong/luongthemgio/chitiet",
        QuanLyQuyLuong: "/luong/quyluong",
    },
    ThuLaoKhongChuyenTrach: {
        DanhSach: "/thulaokct",
        ChiTiet: "/thulaokct/chitiet"
    },
    NgayNghi:{
        DanhSach: "/ngaynghi",
        ChiTiet: "/ngaynghi/chitiet"
    },
    DanhMuc:{
        ChucVu: "/chucvu",
        LoaiHopDong: "/loaihopdong",
        NhomNhanSu: "/nhomnhansu",
        BacLuong: "/bacluong",
        HeSoLuong: "/hesoluong",
        ChucDanhChuyenMon: "/chucdanhchuyenmon",
        ChucVuDang: "/chucvudang",
        ChucVuDoan: "/chucvudoan",
        ChuyenNganhDaoTao: "/chuyennganhdaotao",
        CauHinhPhuCap: "/cauhinhphucap",
        QuanLyThongBaoLogin: "/quanlythongbaologin",
        QuyetDinh: "/quyetdinh",
        NhomLyDoNghiViec: "/nhomlydonghiviec",
        TrinhDoHV: "/trinhdohocvan",
        DMCoSo: "/dmcoso",
        DMBoPhanKiemKe: "/dmbophankiemke",
    },
    CongViec: {
        Them: "/congviec/them",
        GiaoViec: "/congviec/giaoviec",
        Xem: "/congviec/xem",
        DanhSach: "/congviec/danhsach",
    },
    Thue: {
        DsQuyetToanThuongXuyen: "/quyet-toan-thue-thuong-xuyen",
        ChiTietQuyetToanThuongXuyen: "/quyet-toan-thue-thuong-xuyen/chitiet",
        DsThueKhongThuongXuyen: "/Thue/ThueKhongThuongXuyen",
        ChiTietThueKhongThuongXuyen: "/Thue/ThueKhongThuongXuyen/ChiTiet",
        TongHopThueKTXTheoNam: "/QuyetToanKhongThuongXuyen",
        ChiTietTongHopThue: "/tonghopthue/chitiet",
        TongHopThue: "/tonghopthue"
    },
    TaiSan: {
        DanhSach: "/taisan/danhsach",
        ChiTiet: "/taisan/chitiet",
        Xem: "/taisan/xem",
        ThongKe: "/taisan/thongke",
        DotKiemKe: "/taisan/dotkiemke",
        ChiTietDotKiemKe: "/taisan/dotkiemke/chitiet",
        KiemKeTaiSan: "/taisan/kiemke",
        ChiTietBienBanKiemKe: "/taisan/kiemke/bienbankiemke/chitiet",
        KiemKeAllow: "/taisan/kiemke/allow",
        KeKhai: "/nhansu/kekhaits",
        KeKhaiToanDonVi: "/nhansu/kekhaits/toandonvi",
    },
    KeKhaiTaiSan: {
        DanhSach: "/nhansu/kekhaits",
        ChiTiet: "/nhansu/kekhaits/chitiet",
        ToanDonVi: "/nhansu/kekhaits/toandonvi",
    },
    BienBanBanGiao: {
        DanhSach: "/taisan/bienbanbangiao",
        ChiTiet: "/taisan/bienbanbangiao/chitiet",
        Xem: "/taisan/bienbanbangiao/xem",
        XacNhan: "/taisan/bienbanbangiao/xacnhan"
    },
    DeXuatNhuCauTaiSan: {
        DanhSach: "/taisan/dexuat",
        ChiTiet: "/taisan/dexuat/chitiet",
        Xem: "/taisan/dexuat/xem"
    },
    ThanhLyTaiSan: {
        DanhSach: "/taisan/thanhly",
        ChiTiet: "/taisan/thanhly/chitiet",
        Xem: "/taisan/thanhly/xem"
    }
};